import { SignupPayload, assignRef, validateSignup, verifySportEmail } from "./Login";
import firebaseFunParliament, { auth, db, assignFunParliament } from "firebaseFunParliament"

import { Callback } from "./utils";
import { User } from "firebase/auth";
import { getReferUser, saveUserData } from "../../Contexts/User";
import funParliament from "firebaseFunParliament";
export const SignupRegularForFunParliament = async (
    payload: SignupPayload,
    callback: Callback<User>,
    userData?: { [key: string]: any },
    parentEmailId?: any
) => {
    try {
        console.log(parentEmailId, 'parentEmailIdcoin');
        validateSignup(payload);
        const auth = funParliament.auth();
        const userCredential = await auth.createUserWithEmailAndPassword(
            payload.email,
            payload.password
        );
        if (auth?.currentUser) {
            // await sendEmailVerification(auth?.currentUser);
            const referUser = await getReferUser(funParliament.firestore(), parentEmailId);

            await saveUserData((auth?.currentUser?.uid || ''), db, {
                // displayName: await generateUsername(),
                ...userData,
                firstTimeLogin: false,
                isVoteToEarn: true,
                parent: referUser?.uid,
                uid: auth?.currentUser?.uid
            });
            // await assignCoinParliament({ parent: referUser?.uid, child: auth?.currentUser?.uid })

            await assignRef(referUser?.uid, auth?.currentUser?.uid, process.env.REACT_APP_COIN_API || '')
            await verifySportEmail(auth?.currentUser?.uid, (auth?.currentUser?.email || ''), (process.env.REACT_APP_COIN_API || ''));
        } else {
            console.log('funParliament', auth);
        }
        //@ts-ignore
        // callback.successFunc(userCredential.user);
        return true;
    } catch (e) {
        // @ts-ignore
        console.log('funParliament error', e.code);
        // @ts-ignore
        if (e?.code) {
            // @ts-ignore
            const matches = e.code.replace("auth/", "");
            const lastmatches = matches.replace(/\b(?:-)\b/gi, " ");
            // callback.errorFunc({ message: '' /* lastmatches */ } as Error);
        }
        return false;
    }
};